// LIBRARIES //
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Dialog from '@material-ui/core/Dialog';
import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

// COMPONENTS //
import { GoogleReviewResponse } from 'components/landlord_app/properties/components/GoogleReview/GoogleReviewResponse';
import { GoogleReviewForm } from 'components/landlord_app/properties/components/GoogleReview/GoogleReviewForm';

// HELPERS //
import { getTranslatedString } from 'helpers/i18n';

export const GOOGLE_REVIEW_FORM = 'GOOGLE_REVIEW_FORM';
export const GOOGLE_REVIEW_SUCCESS = 'GOOGLE_REVIEW_SUCCESS';
export const GOOGLE_REVIEW_ERROR = 'GOOGLE_REVIEW_ERROR';

const GoogleReview = ({
  fullScreen,
  dialogOpen,
  toggleDialog,
  createGoogleReview,
  getProperties,
  propertyId,
  minimumRating,
  googleReviewLink,
  googleReviewActive,
  minimumLandlordRating,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [googleReviewFormStep, setGoogleReviewFormStep] = useState(GOOGLE_REVIEW_FORM);
  const [googleReviewRating, setGoogleReviewRating] = useState();
  const [disableConfirmation, setDisableConfirmation] = useState(false);

  const handleSubmit = data => {
    data.google_reviews_active = !disableConfirmation;

    setIsSubmitting(true);
    createGoogleReview(data, propertyId)
      .then(resp => {
        getProperties();
        setIsSubmitting(false);
        setGoogleReviewFormStep(GOOGLE_REVIEW_SUCCESS);
      })
      .catch(error => {
        setIsSubmitting(false);
        setGoogleReviewFormStep(GOOGLE_REVIEW_ERROR);
        console.error(error);
      });
  };

  const handleClose = () => {
    setGoogleReviewFormStep(GOOGLE_REVIEW_FORM);
    setGoogleReviewRating();
    toggleDialog();
    setDisableConfirmation(false);
  };

  const handleDisableConfirmation = () => {
    setDisableConfirmation(!disableConfirmation);
  };

  const googleReviewFormSchema = Yup.object().shape({
    google_reviews_minimum_rating: Yup.string(),
    google_review_link: Yup.string().url(
      getTranslatedString('landlordPortal.promotions.invalidUrl')
    ),
  });

  return (
    <Dialog
      disableBackdropClick
      fullScreen={fullScreen}
      open={dialogOpen}
      onClose={handleClose}
      classes={{
        paper: 'form-dialog',
      }}
    >
      {googleReviewFormStep === GOOGLE_REVIEW_FORM && (
        <Formik
          initialValues={{
            google_reviews_minimum_rating: minimumRating,
            google_review_link: googleReviewLink,
            google_reviews_active: !googleReviewActive,
          }}
          validationSchema={googleReviewFormSchema}
          onSubmit={values => handleSubmit(values)}
        >
          {({ values, handleChange, setFieldValue, submitForm, errors, touched }) => (
            <GoogleReviewForm
              values={values}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              submitForm={submitForm}
              handleClose={handleClose}
              isSubmitting={isSubmitting}
              setGoogleReviewRating={setGoogleReviewRating}
              disableConfirmation={disableConfirmation}
              minimumLandlordRating={minimumLandlordRating}
              errors={errors}
              touched={touched}
              handleDisableConfirmation={handleDisableConfirmation}
              googleReviewActive={googleReviewActive}
            />
          )}
        </Formik>
      )}
      {[GOOGLE_REVIEW_SUCCESS, GOOGLE_REVIEW_ERROR].includes(googleReviewFormStep) && (
        <GoogleReviewResponse
          handleClose={handleClose}
          googleFormStep={googleReviewFormStep}
          rating={googleReviewRating || minimumRating}
          disableConfirmation={disableConfirmation}
        />
      )}
    </Dialog>
  );
};

export default withMobileDialog()(GoogleReview);
